import { isSpSize } from "../common/utils/isSpSize";

class Space {
  // ---------------------------------------------------------------------------
  // --	Space
  // ---------------------------------------------------------------------------

  constructor() {
    //DOM参照
    this.$space = document.querySelector(".p-home-space");

    //タイムライン生成
    this.tl = gsap.timeline().pause();
    this.$space.querySelectorAll(".js-parallax-item").forEach((item) => {
      const model = JSON.parse(item.dataset.model);
      const startPos = { x: 0, y: 0 };
      if (model.x) startPos.x = model.x;
      if (model.y) startPos.y = model.y;
      gsap.set(item, startPos);
      this.tl.to(
        item,
        {
          x: 0,
          y: 0,
          ease: "power1.out",
          duration: 1,
        },
        "<"
      );
    });

    //スクロールハンドリング
    window.addEventListener("scroll", this.update.bind(this));

    //リサイズハンドリング
    window.addEventListener("resize", this.update.bind(this));

    //初回アップデート
    this.update();
  }

  update() {
    //Windowの高さ
    const windowH = window.innerHeight;

    //SPACEエリアのY座標
    const targetY = this.$space.getBoundingClientRect().y;

    //エリア全体のスクロールの割合
    const maxY = windowH;
    const minY = -(this.$space.getBoundingClientRect().height - windowH);
    let rate = -((targetY - maxY) / (maxY - minY));
    if (rate < 0) rate = 0;
    if (rate > 1) rate = 1;

    //パララックス
    this.tl.progress(rate);
  }

  // ---------------------------------------------------------------------------
}

export default Space;
